/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { createDialogRoute } from '@gh/common-shared';
import { JobFinderBusinessService } from '../../resources/job-finder-business.service';
import { JobFinderDialogComponent } from './job-finder-dialog.component';

export const jobFinderDialogRoute = createDialogRoute({
  component: JobFinderDialogComponent,
  init: JobFinderBusinessService,
});
